// @ts-nocheck
/**
 * Custom slideshow web component – uses Swiper for sliding behavior.
 * Class-based custom element; all selectors use .custom-slideshow and .custom-slideshow-*.
 */
(function () {
  class CustomSlideshow extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    init() {
      if (typeof window.Swiper === 'undefined' || this.swiper) return;

      const container = this.querySelector('.custom-slideshow__container');
      if (!container) return;

      const prevEl = this.querySelector('.swiper-button-prev');
      const nextEl = this.querySelector('.swiper-button-next');
      const paginationEl = this.querySelector('.custom-slideshow__pagination');

      const autoplayEnabled = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || '5000', 10);

      const config = {
        init: false,
        speed: 500,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        observer: true,
        observeParents: true,
        wrapperClass: 'custom-slideshow__wrapper',
        slideClass: 'custom-slideshow__slide',
        navigation:
          prevEl && nextEl
            ? { nextEl, prevEl }
            : false,
        pagination:
          paginationEl
            ? {
                el: paginationEl,
                clickable: true,
                bulletClass: 'swiper-pagination-bullet',
                bulletActiveClass: 'swiper-pagination-bullet-active',
              }
            : false,
        autoplay: autoplayEnabled
          ? { delay: autoplaySpeed, disableOnInteraction: false }
          : false,
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          paginationBulletMessage: 'Go to slide {{index}}',
        },
        on: {
          init: (swiper) => {
            swiper.updateAutoHeight(0);
          },
          slideChangeTransitionEnd: (swiper) => {
            swiper.updateAutoHeight(300);
          },
          resize: (swiper) => {
            swiper.updateAutoHeight(0);
          },
        },
      };

      this.swiper = new window.Swiper(container, config);
      this.swiper.init();

      const images = container.querySelectorAll('img');
      images.forEach((image) => {
        image.addEventListener(
          'load',
          () => {
            if (this.swiper && !this.swiper.destroyed) {
              this.swiper.updateAutoHeight(0);
            }
          },
          { once: true }
        );
      });
    }

    connectedCallback() {
      if (typeof window.Swiper !== 'undefined') {
        this.init();
        return;
      }
      const onSwiper = () => {
        window.removeEventListener('load', onSwiper);
        if (typeof window.Swiper !== 'undefined') this.init();
      };
      window.addEventListener('load', onSwiper);
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('custom-slideshow')) {
    customElements.define('custom-slideshow', CustomSlideshow);
  }
})();
